export default __webpack_public_path__ + "static/media/compliancy-group-logo.e7e503cd.png";